// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ko from './locale/ko.json';
import en from './locale/en.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ko: { translation: ko },
            en: { translation: en },
        },
        lng: localStorage.getItem('language') || 'ko',
        fallbackLng: 'ko',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
